import gql from "graphql-tag";
import { Location } from "../baseTypes";
export default gql`
  mutation UpdateLocation($input: UpdateLocationInput!) {
    updateLocation(input: $input) {
      name
      id
      companyId
      locationId
      address {
        street
        number
        city
        zip
        country
      }
      email
      phone
      healthDepartmentEmail
      healthDeparmentNumber
      enableAutoEmail
    }
  }
`;
export interface UpdateLocationMutation {
  updateLocation: Location | null;
}
